var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('img',{attrs:{"id":"photo","src":require("../public/assets/IMG_3187.jpg")}}),_vm._v(" "),_c('Content',{attrs:{"msg":"Divyanth Jayaraj"}}),_vm._v(" "),_c('site-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }